<template>
<svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.925293 1L28.5294 26.9312" stroke="white" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M29.6695 1L2.06543 26.9312" stroke="white" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="round"/>
</svg>
</template>
